module.exports = __webpack_public_path__ + "cf7d315766ca88bebfec0ff3849b7a7d.png";